module.exports = __webpack_public_path__ + "Roboto-Bold.e31fcf1885e371e19f57.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Bold.ttf
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Bold.ttf
// module chunks = styles